import * as yup from 'yup'
import YupPassword from 'yup-password'

YupPassword(yup)

export const validator = yup
